import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'

class EligibilityInquiryType extends ActiveRecord {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined

    this._id = init.id
    this._employee_id = init.employee_id
    this._description = init.description
    this._eligibility_inquiry_issues_attributes =
      init.eligibility_inquiry_issues
    this._eligibility_inquiry_members_attributes =
      init.eligibility_inquiry_members
  }

  static shape = {
    id: PropTypes.string,
    employee_id: PropTypes.string,
    description: PropTypes.string,
    eligibility_inquiry_issues_attributes: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        issue_type: PropTypes.string,
        created_at: PropTypes.string,
        updated_at: PropTypes.string
      })
    ),
    eligibility_inquiry_members_attributes: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        name: PropTypes.string,
        dob: PropTypes.string,
        cardholder_id: PropTypes.string,
        coverage_start_date: PropTypes.string,
        group_id: PropTypes.string,
        plan_name: PropTypes.string,
        reason_for_manual_add: PropTypes.string,
        new_cardholder_id_needed: PropTypes.bool,
        created_at: PropTypes.string,
        updated_at: PropTypes.string
      })
    )
  }

  get id() {
    return this._id
  }

  get employee_id() {
    return this._employee_id
  }

  get description() {
    return this._description
  }

  get eligibility_inquiry_issues_attributes() {
    return this._eligibility_inquiry_issues_attributes || []
  }

  get eligibility_inquiry_members_attributes() {
    return this._eligibility_inquiry_members_attributes || []
  }
}

export default EligibilityInquiryType
